import React from 'react';
import { Slider, FormItem } from 'formik-antd';
import 'antd/dist/antd.less';
import styled from 'styled-components';

export default function SliderInput({ name, label, extra, ...props }) {
	return (
		<FormItem name={name} label={label} extra={extra}>
			<StyledSlide {...props} name={name} />
		</FormItem>
	);
}

//Styles
const StyledSlide = styled(Slider)`
	&&:hover {
		.ant-slider-track {
			background-color: #ffd97a;
			border-radius: 4px;
		}
		.ant-slider-handle {
			background-color: #fff;
			border: 2px solid #ffd97a;
		}
	}
	.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
		border-color: #ffc852;
	}
	.ant-slider-handle:focus {
		border-color: #ffb133;
		outline: none;
		-webkit-box-shadow: 0 0 0 5px rgba(255, 157, 0, 0.2);
		box-shadow: 0 0 0 5px rgba(255, 157, 0, 0.2);
	}
	.ant-slider-track {
		background-color: #ffd97a;
		border-radius: 4px;
	}
	.ant-slider-handle {
		background-color: #fff;
		border: 2px solid #ffd97a;
	}
`;
